import { useObserver } from 'mobx-react-lite'
import React, { FC, useContext } from 'react'
import * as css from './CancelProductWrapper.css'
import Typography from '@components/std-components/Typography'
import { CircularLoading } from '@components/UI-Components/CircularLoading'
import { orderManagementService } from '@services/wholesale/OrderManagementService'
import {
  isRetailChannel,
  isWholesaleChannel
} from '@services/wholesale/wholesaleBuyingSessionGroupsServices'
import { useEnumListByName } from '@modules/wholesale/buyingGroupSummary/graphql/hooks'
import { config } from '@config'
import filter from 'lodash/filter'
import { useTranslation } from 'react-i18next'
import { CancelProductComponent } from '../component/CancelProductComponent'
import { CancelProductContext } from '../context/cancelProduct-context'

interface CancelProductProps {
  product: any
  bsgChannels: Array<string>
  closePopup?: (flag: boolean) => void
}

export const CancelProductWrapper: FC<CancelProductProps> = ({
  product,
  bsgChannels,
  closePopup
}) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const {
      uiStore: { productOrderDetails, isProductOrdersInProgress }
    } = useContext(CancelProductContext)

    const hasRetailChannel = isRetailChannel(bsgChannels)
    const hasWholesaleChannel = isWholesaleChannel(bsgChannels)

    //Table Data
    const [{ data: enumData }] = [
      useEnumListByName(config?.appConfig?.enumerations?.orderStatus?.NAME ?? null)
    ]
    const processedOrderData = orderManagementService.processAndSearchOrderData(
      {
        orders: productOrderDetails?.orders ?? [],
        statusEnumValues: enumData?.findEnumList?.Items?.[0]?.Values ?? [],
        buyingSessionGroup: productOrderDetails?.buyingSessionGroup ?? null
      } as any,
      '',
      null,
      t
    )
    const orderStatusConfig = config?.appConfig?.enumerations?.orderStatus
    const sentToSAPStatus = orderStatusConfig.ORDER_STATUS_VALUES['Sent to SAP']
    const disabledOrders = filter(
      processedOrderData || [],
      order =>
        order.statusEnumValue === sentToSAPStatus || order.isCancelProductStatusDisabled
    )
    const selectedRows = filter(
      processedOrderData || [],
      order =>
        order.statusEnumValue !== sentToSAPStatus && !order.isCancelProductStatusDisabled
    )

    return (
      <div className={css.popupWrapper}>
        <div className={css.popupHeader}>
          <Typography variant={'buttonlabel'} classes={css.title}>
            {t('productDetails.cancelProductPopup.title', 'CANCEL PRODUCT')}
          </Typography>
        </div>
        <div className={css.popupContent}>
          {isProductOrdersInProgress ? (
            <CircularLoading />
          ) : (
            <>
              {/* Cancel Product Component */}
              <CancelProductComponent
                product={product}
                productOrderDetails={productOrderDetails}
                selectedRows={selectedRows}
                processedOrderData={processedOrderData}
                disabledOrders={disabledOrders}
                hasRetailChannel={hasRetailChannel}
                hasWholesaleChannel={hasWholesaleChannel}
                handleCancel={closePopup}
              />
            </>
          )}
        </div>
      </div>
    )
  })
}
